import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const searchUsers = async ({ params }: any) => {
  const urlBuilder = createUrlBuilder(`/community/users`);
  const response = await getRequest(AppService, urlBuilder.toString(), params);
  return response;
};

export const searchUser = async ({ userId }: any) => {
  const urlBuilder = createUrlBuilder(`/community/users/${userId}`);
  const response = await getRequest(AppService, urlBuilder.toString());
  return response;
};
